<template>
<div>
    <bar-manut 
        single-entity="Alíquota FCP"
        plural-entity="Alíquota FCP"
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div class="default-container">
        <div class="row">
            <form-field v-model="regrafcp.uf" type="select" col="2" ref="uf"
                :metadata="metadata.regrafcp.uf" :select-options="estadoList"
                name="uf" :v-errors="errors" v-validate="metadata.regrafcp.uf.validator"></form-field>
            <form-field v-model="regrafcp.ncm" type="select2" col="6" 
                :metadata="metadata.regrafcp.ncm" :select2="{entity: 'ncm', minlength: 1}"
                name="ncm" :v-errors="errors" v-validate="metadata.regrafcp.ncm.validator"></form-field>
            <form-field v-model="regrafcp.exncm" type="number" col="2" 
                :metadata="metadata.regrafcp.exncm"
                name="exncm" :v-errors="errors" v-validate="metadata.regrafcp.exncm.validator"></form-field>
            <form-field v-model="regrafcp.afcp" type="value" col="2"
                :metadata="metadata.regrafcp.afcp" :precision="2"
                name="afcp" :v-errors="errors" v-validate="metadata.regrafcp.afcp.validator"></form-field>
            <form-field v-model="regrafcp.afcpst" type="value" col="2"
                :metadata="metadata.regrafcp.afcpst" :precision="2"
                name="afcp" :v-errors="errors" v-validate="metadata.regrafcp.afcpst.validator"></form-field>
        </div>                
    </div>
    <br>
    <div class="row" v-if="!editing">
        <div class="col-md-12 col-12">
            <v-button label="Salvar e Adicionar Novo" title="" :nb-btdef="true" @click="handleSave(true)"></v-button>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            regrafcp: {...this.$store.getters.getEntities.regrafcp},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            estadoList: [],
            saveAndNew: false,
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        },
    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        async loadEstados () {
            //carrega lista de estados cadastrados
            await this.$store.dispatch('loadEstadoRegras')
            if (this.$store.getters.getEstadoList) {
                this.estadoList = this.$store.getters.getEstadoList.map(function (obj) {
                return { id: obj.uf, text: obj.uf }
                })
            }
        },

        handleSave (saveAndNew) {
            //BOTAO SALVAR
            this.saveAndNew = saveAndNew
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        addNew () {
            //inclui novo registro após gravação do registro anterior (botao salvar e adicionar novo)
            this.regrafcp.ncm = null
            this.regrafcp.exncm = null
            this.regrafcp.afcp = null
            this.regrafcp.afcpst = null
            this.saveAndNew = false
            this.$refs.uf.$el.querySelector('select').focus()
            //limpa os erros de validação
            this.$nextTick(function () {
                this.$validator.reset()
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadRegrafcp', { id: this.index } )
            if (this.$store.getters.getRegrafcp) {
                this.regrafcp = {...this.$store.getters.getRegrafcp}
            }  
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/regrafcp/' + this.regrafcp.codregrafcp

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/regrafcp/'
            var sendData = { regrafcp: [] }

            sendData.regrafcp.push(this.regrafcp)

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                if (!this.saveAndNew) {
                    this.closeForm()
                } else {
                    this.addNew()
                }
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.loadEstados()

        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }

        this.$refs.uf.$el.querySelector('select').focus()
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/regrafcp-form.vue